export default __webpack_public_path__ + "static/media/Aditya Ahlawat.044a0d37.jpg";